module.exports = __webpack_public_path__ + "img/img-tec.b9d15e5a.png";